<template>
  <div class="recharge-settings">
    <el-button type="primary" @click="addRechargeOption" style="margin-bottom: 20px;">
      <i class="el-icon-plus"></i> 添加充值选项
    </el-button>

    <el-table :data="rechargeOptions" border style="width: 100%">
      <el-table-column prop="amount" label="充值金额" width="180">
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="bonus" label="赠送金额" width="180">
        <template slot-scope="scope">
          ¥{{ scope.row.bonus }}
        </template>
      </el-table-column>
      <el-table-column prop="description" label="描述"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="editRechargeOption(scope.$index)">编辑</el-button>
          <el-button size="mini" type="danger" @click="removeRechargeOption(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑充值选项对话框 -->
    <el-dialog
        :title="isEditing ? '编辑充值选项' : '添加充值选项'"
        :visible.sync="dialogVisible"
        width="50%"
        :append-to-body="true"
    >
      <el-form :model="currentOption" label-width="120px">
        <el-form-item label="充值金额">
          <el-input-number
              v-model="currentOption.amount"
              :min="100"
              :max="10000"
              :step="100"
              controls-position="right"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="赠送金额">
          <el-input-number
              v-model="currentOption.bonus"
              :min="0"
              :max="5000"
              :step="50"
              controls-position="right"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="描述">
          <el-input v-model="currentOption.description" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRechargeOption">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RechargeSettings',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      rechargeOptions: JSON.parse(JSON.stringify(this.shop.rechargeSettings?.options || [])),
      dialogVisible: false,
      isEditing: false,
      editingIndex: -1,
      currentOption: {
        amount: 1000,
        bonus: 100,
        description: ''
      }
    }
  },
  methods: {
    addRechargeOption() {
      this.isEditing = false
      this.currentOption = {
        amount: 1000,
        bonus: 100,
        description: ''
      }
      this.dialogVisible = true
    },
    editRechargeOption(index) {
      this.isEditing = true
      this.editingIndex = index
      this.currentOption = JSON.parse(JSON.stringify(this.rechargeOptions[index]))
      this.dialogVisible = true
    },
    removeRechargeOption(index) {
      this.$confirm('确定要删除此充值选项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.rechargeOptions.splice(index, 1)
        this.$message.success('删除成功')
      })
    },
    saveRechargeOption() {
      if (this.currentOption.amount <= 0) {
        this.$message.error('充值金额必须大于0')
        return
      }

      if (this.isEditing) {
        this.rechargeOptions.splice(this.editingIndex, 1, this.currentOption)
      } else {
        this.rechargeOptions.push(this.currentOption)
      }

      this.dialogVisible = false
      this.$emit('save', { options: this.rechargeOptions })
    }
  }
}
</script>

<style scoped>
.recharge-settings {
  padding: 20px;
}
</style>